import { gql } from '@/shared/types/gql';

/**
 * Signs the user in to Trade System: the API mints a single-use hand-off token
 * for them and answers with Trade System's callback (`redirectUri`, which it
 * accepts only from its allowlist), the token in its fragment.
 */
export const CREATE_TRADE_SYSTEM_HANDOFF = gql`
  mutation CreateTradeSystemHandoff($redirectUri: String!) {
    createTradeSystemHandoff(redirectUri: $redirectUri) {
      redirectUrl
    }
  }
`;
